// Marketing · Embudos (montado en /marketing/embudos/*): lista con plantillas y detalle con pasos.
import type { JSX } from "react";
import { Route, Routes } from "react-router-dom";
import { FunnelList } from "./funnels/FunnelList.tsx";
import { FunnelDetail } from "./funnels/FunnelDetail.tsx";

export function MktFunnels(): JSX.Element {
  return (
    <Routes>
      <Route index element={<FunnelList />} />
      <Route path=":id" element={<FunnelDetail />} />
    </Routes>
  );
}
